const orderApi = '/order-service/rest/api/external';
const paymentsApi = '/payment-service/api/external';

export const deferredPaymentsContext = {
  all: `${orderApi}/creditApplications`,
  allPostponements: `${orderApi}/postponementApplications`,
  allFactoring: `${orderApi}/factoringApplications`,
  postponementById: `${orderApi}/postponementApplications/{id}`,
  factoringById: `${orderApi}/factoringApplications/{id}`,
  addAttachment: `${orderApi}//creditApplications/attachments`,
  byId: `${orderApi}/creditApplications/{id}`,
  operatorDecision: `${orderApi}/creditApplications/{id}/operatorDecision`,
  sellerDecision: `${orderApi}/postponementApplications/{id}/sellerDecision`,
  sign: `${orderApi}/creditApplications/{id}/sign`,
  sellerSign: `${orderApi}/postponementApplications/{id}/sign`,
  postponementChat: `${orderApi}/postponementApplications/{id}/chat`,
  status: `${orderApi}/creditApplications/{id}/status`,
  creditChat: `${orderApi}/creditApplications/{id}/chat`,
  messages: `${orderApi}/creditApplications/{id}/messages`,
  loanById: `${paymentsApi}/credit/offers/{id}`,
  allLoans: `${paymentsApi}/credit/offers`,
  creditAttachments: `${orderApi}/creditApplications/attachments`,
  postponementApplicationById: `${paymentsApi}/postponement/offers/{id}`,
  postponementAttachments: `${orderApi}/postponementApplications/attachments`,
  factoringApplicationById: `${paymentsApi}/factoring/offers/{id}`,
  allFactoringApplications: `${paymentsApi}/factoring/offers`,
  allPostponementApplications: `${paymentsApi}/postponement/offers`,
  factoringSign: `${orderApi}/factoringApplications/{id}/sign`,
  factoringChat: `${orderApi}/factoringApplications/{id}/chat`,
  factoringAttachments: `${orderApi}/factoringApplications/attachments`,
  factoringOperatorDecision: `${orderApi}/factoringApplications/{id}/operatorDecision`,
  factoringSellerDecision: `${orderApi}/factoringApplications/{id}/sellerDecision`,
  factoringChangeSum: `${orderApi}/factoringApplications/{id}/requestedSum`,
  factoringConfirmFund: `${orderApi}/factoringApplications/{id}/fund`,
  factoringInvoice: `${orderApi}/factoringApplications/{id}/invoice`,
  factoringInvoiceSign: `${orderApi}/factoringApplications/{id}/invoice/sign`,
  offers: {
    credits: {
      all: `${paymentsApi}/credit/offers`,
      byId: `${paymentsApi}/credit/offers/{id}`,
    },
    factoring: {
      all: `${paymentsApi}/factoring/offers`,
      byId: `${paymentsApi}/factoring/offers/{id}`,
    },
    postponements: {
      all: `${paymentsApi}/postponement/offers`,
      byId: `${paymentsApi}/postponement/offers/{id}`,
    },
  },
};
